<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算执行报告</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.mk_report_id">
                <el-input v-model="mk_report_id" placeholder="请输入单据编号" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.reim_person_rid">
                <el-select style="width: 100%" v-model="reim_person_rid" placeholder="请选择报销人" size="mini" clearable filterable>
                    <el-option v-for="item in beneficiaryOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.cover_person_rid">
                <el-select style="width: 100%" v-model="cover_person_rid" placeholder="请选择承担人" size="mini" clearable filterable>
                    <el-option v-for="item in beneficiaryOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.entity_rid">
                <el-select
                    v-model="entity_name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入实体搜索"
                    :remote-method="remoteEntity"
                    :loading="loadingEntity"
                    clearable
                    @focus="focusOptions"
                    value-key="rid"
                    @change="entityChange"
                >
                    <el-option v-for="item in entityOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.supplier_rid">
                <el-select
                    v-model="supplier_name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入供应商搜索"
                    :remote-method="remoteEntity"
                    :loading="loadingEntity"
                    clearable
                    @focus="focusOptions"
                    value-key="rid"
                    @change="supplierChange"
                >
                    <el-option v-for="item in entityOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入报销事由" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.remark">
                <el-input v-model="remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增预算执行报告</el-button>
                <el-button size="small" plain @click="update" v-if="postList.updateBtn" :loading="btnLoading">刷新支付信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_execution_report"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    item.prop == 'mk_report_id' ||
                                    item.prop == 'reim_person_name' ||
                                    item.prop == 'cover_person_name' ||
                                    item.prop == 'supplier_name' ||
                                    item.prop == 'entity_name'
                                "
                            >
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'mk_report_type'">
                                <span v-if="scope.row.mk_report_type == '对公'" style="color: #f56c6c">对公</span>
                                <span v-else style="color: #67c23a">对私</span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="提交" placement="top-start">
                            <i class="el-icon-success" @click="submit(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetObjectListComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_execution_report'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            mk_report_id: '',
            name: '',
            remark: '',
            entity_rid: '',
            entity_name: '',
            reim_person_rid: '',
            cover_person_rid: '',
            supplier_rid: '',
            supplier_name: '',
            loadingEntity: false,
            entityOptions: [],
            beneficiaryOptions: [],
            btnLoading: false
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    //在moutend之前赋值
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['report_params']) {
                this.page = paramsList['report_params'].page;
                this.row = paramsList['report_params'].row;
                // this.data_name = paramsList['budgetAccount_params'].data_name;
                // this.sort = paramsList['budgetAccount_params'].sort;
                this.name = paramsList['report_params'].name;
                this.mk_report_id = paramsList['report_params'].mk_report_id;
                this.remark = paramsList['report_params'].remark;
                this.entity_rid = paramsList['report_params'].entity_rid;
                this.entity_name = paramsList['report_params'].entity_name;
                this.reim_person_rid = paramsList['report_params'].reim_person_rid;
                this.cover_person_rid = paramsList['report_params'].cover_person_rid;
                this.supplier_rid = paramsList['report_params'].supplier_rid;
                this.supplier_name = paramsList['report_params'].supplier_name;
            }
        }
    },
    mounted() {
        this.getPrincipal(); //获取受益人  负责人下拉
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                if (this.postList.params.reim_person_rid) {
                    this.reim_person_rid = this.postList.params.reim_person_rid;
                }
                //获取列表
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //刷新支付信息
        update() {
            var params = {};
            let messages = '此操作将刷新支付信息，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api
                        .refreshPayment(params)
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '刷新成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刷新'
                    });
                });
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_execution_report', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_execution_report;
        },
        //获取受益人  负责人下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.beneficiaryOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //实体 供应商共用一个框
        focusOptions() {
            this.loadingEntity = false;
            this.entityOptions = [];
        },
        //上级名称远程搜索方法
        remoteEntity(query) {
            if (query !== '') {
                this.loadingEntity = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.loadingEntity = false;
                                this.entityOptions = res.data;
                            }, 200);
                        } else {
                            this.entityOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.loadingEntity = false;
                this.entityOptions = [];
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 3
                }
            });
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        submit(rid) {
            this.$confirm('您确定要提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['budgetExecutionReportSubmit']({ rid: rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },

        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetExecutionReportDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        // 从后台获取数据,重新排序 把排序值存起来
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (newParamsList['report_params']) {
                newParamsList['report_params'].data_name = val.prop;
                newParamsList['report_params'].sort = this.sort;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'mk_report_id') {
                this.$router.push({
                    path: '/budgetReportDetails',
                    query: {
                        id: row.rid,
                        mk_report_id: row.mk_report_id,
                        mk_report_type: row.mk_report_type,
                        supplier_rid: row.supplier_rid ? row.supplier_rid : ''
                    }
                });
            } else if (prop == 'reim_person_name') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.reim_person_rid
                    }
                });
            } else if (prop == 'cover_person_name') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.cover_person_rid
                    }
                });
            } else if (prop == 'supplier_name') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.supplier_rid
                    }
                });
            } else if (prop == 'entity_name') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.entity_rid
                    }
                });
            }
        },
        entityChange(value) {
            if (value) {
                this.entity_rid = value.rid;
                this.entity_name = value.name;
            } else {
                this.entity_rid = '';
                this.entity_name = '';
            }
        },
        supplierChange(value) {
            if (value) {
                this.supplier_rid = value.rid;
                this.supplier_name = value.name;
            } else {
                this.supplier_rid = '';
                this.supplier_name = '';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            //判断等于1 点击搜索时重置page和row参数
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                name: this.name,
                sort: [this.data_name, this.sort],
                mk_report_id: this.mk_report_id,
                remark: this.remark,
                entity_rid: this.entity_rid,
                entity_name: this.entity_name,
                reim_person_rid: this.reim_person_rid,
                cover_person_rid: this.cover_person_rid,
                supplier_rid: this.supplier_rid,
                supplier_name: this.supplier_name,
                is_export: type_data
            };
            //当点击或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['report_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .budgetExecutionReportLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['report_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetExecutionReportListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['report_params']) {
                    newParamsList['report_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        sort: [this.data_name, this.sort],
                        mk_report_id: this.mk_report_id,
                        remark: this.remark,
                        entity_rid: this.entity_rid,
                        entity_name: this.entity_name,
                        reim_person_rid: this.reim_person_rid,
                        cover_person_rid: this.cover_person_rid,
                        supplier_rid: this.supplier_rid,
                        supplier_name: this.supplier_name
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['report_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当条数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['report_params']) {
                    newParamsList['report_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        sort: [this.data_name, this.sort],
                        mk_report_id: this.mk_report_id,
                        remark: this.remark,
                        entity_rid: this.entity_rid,
                        entity_name: this.entity_name,
                        reim_person_rid: this.reim_person_rid,
                        cover_person_rid: this.cover_person_rid,
                        supplier_rid: this.supplier_rid,
                        supplier_name: this.supplier_name
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['report_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.mk_report_id = '';
            this.name = '';
            this.remark = '';
            this.entity_rid = '';
            this.entity_name = '';
            this.reim_person_rid = '';
            this.cover_person_rid = '';
            this.supplier_rid = '';
            this.supplier_name = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            //把存储的参数全部清空
            var params = {
                page: 1,
                row: 25,
                name: '',
                sort: ['', ''],
                mk_report_id: '',
                remark: '',
                entity_rid: '',
                entity_name: '',
                reim_person_rid: '',
                cover_person_rid: '',
                supplier_rid: '',
                supplier_name: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['report_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>